import { render } from "./service-provider-1.vue?vue&type=template&id=6be632de&scoped=true&ts=true"
import script from "./service-provider-1.vue?vue&type=script&lang=ts"
export * from "./service-provider-1.vue?vue&type=script&lang=ts"

import "./service-provider-1.vue?vue&type=style&index=0&id=6be632de&lang=scss&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6be632de"]])

export default __exports__